import { Grid, styled } from "@mui/material"

export const ViewSettings = styled(Grid)({
  "fontWeight": 300,
  "gap": 8,
  "cursor": "pointer",
  "& h6": {
    fontWeight: 300
  }
})
